
function getRandom(min, max) {
    return Math.random() * (max - min) + min;
}


export function displayCollage(images) {
    images.forEach(img => {
        img.top = getRandom(0, 80);   
        img.left = getRandom(0, 80); 
        img.width = getRandom(100, 400);

        if (img.src.includes('pilone')) { 
          img.width = getRandom(400, 600);
        }

        if (img.src.includes('spiral')) { 
          img.width = getRandom(100, 300);
        }

        if (img.src.includes('star')) {
          img.class = "rotate";
        }

        if (img.src.includes('etoile.gif') || img.src.includes('tulipes.gif') || img.src.includes('chateau.gif')) {
          img.width = getRandom(150, 210);
        }
      });
      


}




